<template>
  <!-- ShopRowIndividual.vue -->
  <div>
    <template v-for="(a, i) in row.Activities">
      <div
        :key="'shop-row-ind-activities-' + a.EntityHierarchyKey + '-' + i"
        class="product_highlights mb-0"
      >
        <span v-if="a.Difficulty" class>
          <i class="check_icon"></i>
          <!-- <small>Difficulty</small> -->
          <span>{{ a.Difficulty }}</span>
        </span>
        <span v-if="a.Duration" class>
          <i class="check_icon"></i>
          <!-- <small>Duration</small> -->
          <span>{{ a.Duration }}</span>
        </span>
        <span v-if="a.AgeMinimum" class>
          <i class="check_icon"></i>
          <!-- <small>Ages</small> -->
          <span>{{ a.AgeMinimum }}</span>
        </span>
        <span v-if="a.MinHeight" class>
          <i class="check_icon"></i>
          <!-- <small>Min Height</small> -->
          <span>{{ a.MinHeight }}</span>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ["row"],
  computed: {
    fromPrice() {
      return this.row.Activities[0].Rates.find(ele => {
        return ele.IsFromPrice == true;
      });
    }
  }
};
</script>

<style></style>
